import { render, staticRenderFns } from "./AcceptGDPR.vue?vue&type=template&id=5385677f"
import script from "./AcceptGDPR.vue?vue&type=script&lang=js"
export * from "./AcceptGDPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports